import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const FieldSelect = styled.select`
  font-family: GTAmerica, 'GT America';
  width: 100%;
  height: 64px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors['charcoal']};
  border: ${({ error }) =>
    error ? `solid 2px ${colors['error-red']}` : 'none'};
  border-radius: 0px;
  box-shadow: none;
  padding: 22px 25px;
  background-color: ${colors['white']};
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGw0Ljc5NiA2LjAzTDkuNTkzIDB6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgOSkiPgogICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiM0MjQ0NDEiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPGcgZmlsbD0iIzQwNDIzRiIgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0tNy05aDI0djI0SC03eiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==);
  background-size: 24px;
  background-repeat: no-repeat;
  &:focus {
    outline: none;
  }
  &::-ms-expand {
    width: 0;
    height: 0;
  }

  &.ltr {
    background-position: calc(100% - 1em);
  }
  &.rtl {
    background-position: 1em;
  }

  ${media.tabletPortraitUp`
    font-size: 17.5px;
  `};
`;
